import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

interface PersistentCTABarProps {
  onGetAssistant: () => void;
}

export const PersistentCTABar: React.FC<PersistentCTABarProps> = ({ onGetAssistant }) => {
  return (
    <div className="flex items-center justify-between px-4 py-3 bg-muted/50 border-t border-border">
      <span className="text-sm text-muted-foreground">
        Ready to get this assistant for your firm?
      </span>
      <Button 
        size="sm" 
        variant="outline"
        onClick={onGetAssistant}
        className="ml-4"
      >
        Get My Assistant
        <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
    </div>
  );
};

interface InlineConversionPromptProps {
  onGetAssistant: () => void;
}

export const InlineConversionPrompt: React.FC<InlineConversionPromptProps> = ({ onGetAssistant }) => {
  return (
    <div className="flex items-start gap-3 p-4 my-4 bg-brand-teal/5 border border-brand-teal/20 rounded-lg">
      <Sparkles className="h-5 w-5 text-brand-teal flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="text-sm text-foreground mb-2">
          This assistant can be safely configured for your firm's branding, workflows, and escalation rules.
        </p>
        <Button 
          size="sm"
          onClick={onGetAssistant}
          className="bg-brand-teal hover:bg-brand-teal/90"
        >
          Get My Assistant
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
